export default __webpack_public_path__ + "static/media/Group_5498.457afc51.svg";